import React, { ReactNode } from "react";
import PropTypes from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import CloseIcon from "@material-ui/icons/Close";
import Chip from "@material-ui/core/Chip";
import { affinityColors as colors } from "../themes/affinityTheme/styleData";
import { OverridableComponent } from "@material-ui/core/OverridableComponent";
import { ChipTypeMap } from "@material-ui/core/Chip/Chip";

export interface ErrorChipProps extends OverridableComponent<ChipTypeMap> {
  label: ReactNode;
}

export function ErrorChip({ label, ...other }: ErrorChipProps) {
  return (
    <Chip
      avatar={
        <Avatar
          style={{
            backgroundColor: colors.affinityRedDarker.value,
            color: "white"
          }}
        >
          <CloseIcon />
        </Avatar>
      }
      label={label}
      style={{
        color: "white",
        backgroundColor: colors.affinityRedDark.value,
        margin: "0 15px"
      }}
      {...other}
    />
  );
}

ErrorChip.propTypes = {
  label: PropTypes.string
};
